var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0ZM11 1.5C5.75329 1.5 1.5 5.75329 1.5 11C1.5 16.2467 5.75329 20.5 11 20.5C16.2467 20.5 20.5 16.2467 20.5 11C20.5 5.75329 16.2467 1.5 11 1.5ZM8.1875 7.05858L10.9999 9.87096L13.8123 7.05858C13.8499 7.02107 13.9007 7 13.9538 7H15.51C15.6205 7 15.71 7.08954 15.71 7.2C15.71 7.25305 15.689 7.30392 15.6514 7.34143L12.0604 10.932L15.7875 14.6586C15.8656 14.7367 15.8656 14.8633 15.7875 14.9414C15.75 14.9789 15.6991 15 15.6461 15H14.0898C14.0368 15 13.9859 14.9789 13.9484 14.9414L10.9999 11.9925L8.05055 14.9414C8.01305 14.9789 7.96218 15 7.90914 15H6.35381C6.24335 15 6.15381 14.9105 6.15381 14.8C6.15381 14.747 6.17488 14.6961 6.21239 14.6586L9.93892 10.932L6.34835 7.34142C6.27024 7.26332 6.27024 7.13668 6.34835 7.05858C6.38585 7.02107 6.43673 7 6.48977 7H8.04608C8.09912 7 8.14999 7.02107 8.1875 7.05858Z",
    fill: "#1677FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b501ea50db3a54bbb3e7ae6a8014df75.svg";
export { ForwardRef as ReactComponent };